import axios from "axios";

class AuthService
{
    login(credentials)
    {
        return axios.post('/auth/login', credentials);
    }

    getProviders(email)
    {
        return axios.get(`/auth/providers/${encodeURIComponent(email)}`);
    }

    sendMailPinCode(email)
    {
        return axios.get(`/oauth2/mail-pin-code/send/${email}`);
    }

    verifyMailPinCode(email, pin)
    {
        return axios.post(`/oauth2/mail-pin-code/verify/${email}`, {
            pin
        });
    }

    setCompany(companyId)
    {
        return axios.post('/auth/set-company', {
            company_id: companyId
        });
    }

    authDataFromLocalStorage()
    {
        try
        {
            return JSON.parse(localStorage.getItem('authData'));
        }
        catch (e)
        {
            console.error(e);

            return null;
        }
    }

    removeAuthDataFromLocalStorage()
    {
        localStorage.removeItem('authData');
    }

    setAuthDataFromLocalStorage(data)
    {
        localStorage.setItem('authData', JSON.stringify(data));
    }
}

export default AuthService;